import { DatePicker, DatePickerProps } from 'antd';
import React from 'react';
import { uiStore } from 'stores/root_store';

type CustomDatePickerProps = DatePickerProps & {};

export default function CustomDatePicker(props: CustomDatePickerProps) {
  return (
    <DatePicker
      {...props}
      format={props.format ? props.format : 'DD/MM/YYYY'}
      className={
        uiStore.theme.name +
        ' !rounded-sm w-full hover:border-primary [&.ant-picker-focused]:!border-primary [&.ant-picker-focused]:!shadow-none ' +
        props.className
      }
    />
  );
}
